import { ReactElement } from "react";

interface ButtonProps {
  children: ReactElement<any, any>;
  disabled?: boolean;
  onClick: () => void | Promise<void>;
  type?: "button" | "submit" | "reset" | undefined;
  variantion?: "normal" | "danger";
}

function Button({
  disabled,
  children,
  onClick,
  type,
  variantion = "normal",
}: ButtonProps) {
  return (
    <>
      <button
        disabled={disabled}
        className={`${variantion === "normal" ? "from-blu-200 to-blu-600" : ""} disabled:from-grayscale-800 disabled:to-grayscale-400 ${variantion === "danger" ? "from-red-600 to-red-700" : ""} flex grow items-baseline justify-center rounded-lg bg-gradient-to-tr p-2`}
        onClick={onClick}
        type={type ? type : "button"}
      >
        {children}
      </button>
    </>
  );
}

export default Button;
